import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_trash.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2a656e32")

_pushScopeId("data-v-2a656e32")
const _hoisted_1 = { class: "flex h-full w-auto" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "h-4 w-4",
  alt: "delete-image"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_card, {
      class: "relative p-2 rounded-xl border border-gray-lp-1500 bg-white",
      style: {"max-height":"max-content"}
    }, {
      default: _withId(() => [
        (!_ctx.disabled && _ctx.isValidPhoto)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "w-7 h-7 flex items-center justify-center rounded-full bg-white border border-gray-lp-1500 z-10 absolute -top-3 -right-3",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setDefault && _ctx.setDefault(...args)))
            }, [
              _hoisted_2
            ]))
          : _createCommentVNode("", true),
        (_ctx.isValidPhoto && !_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: `relative flex`,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)))
            }, [
              _createVNode("img", {
                src: _ctx.modelValue,
                class: `h-18 w-18 object-cover rounded-xl`,
                alt: "result-image"
              }, null, 8, ["src"])
            ]))
          : (_openBlock(), _createBlock("div", {
              key: 2,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click())),
              onDragover: _cache[4] || (_cache[4] = e => _ctx.setDragAndDrop(e, true)),
              onDragleave: _cache[5] || (_cache[5] = e => _ctx.setDragAndDrop(e, false)),
              onDrop: _cache[6] || (_cache[6] = e => _ctx.onSubmitDrag(e)),
              class: 
          `flex justify-center ${_ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'} h-18 w-18 items-center text-12px rounded-xl bg-gray-lp-1500`
        
            }, [
              _createVNode(_component_Icons, {
                class: "text-red-lp-1000",
                name: "plus-circle"
              })
            ], 34)),
        _createVNode("input", {
          id: String(_ctx.$attrs.id),
          type: "file",
          ref: "file",
          onChange: _cache[7] || (_cache[7] = e => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
          accept: _ctx.accept,
          class: "hidden",
          multiple: ""
        }, null, 40, ["id", "accept"])
      ]),
      _: 1
    })
  ]))
})